<div fxFlexFill fxLayout="column">
  <span fxLayout="row" fxLayoutAlign="end end" ngStyle.xs="font-size:20px">
    <a class="close regular" (click)="close()">Close</a></span
  >

  <mat-dialog-content>
    <div fxLayout="column">
      <img
        alt="image"
        (load)="setLoaded()"
        class="checkOutImage"
        *ngIf="!data?.fromPreview"
        fxHide.xs="true"
        [src]="desktopImage"
        height="100%"
        width="100%"
      />
      <img
        alt="image"
        (load)="setLoaded()"
        class="checkOutImage"
        fxHide="true"
        fxHide.xs="false"
        *ngIf="!data?.fromPreview"
        [src]="mobileImage"
      />
      <img
        alt="image"
        (load)="setLoaded()"
        style="background-size: contain"
        *ngIf="data?.fromPreview"
        fxHide.xs="true"
        src="assets/images/COVID-19_Quarantine_Isolation.png"
        height="100%"
        width="100%"
      />
      <img
        alt="image"
        (load)="setLoaded()"
        style="background-size: contain"
        *ngIf="data?.fromPreview"
        fxHide.xs="false"
        fxHide="true"
        src="assets/images/IvsQ_mobile.png"
        height="100%"
        width="100%"
      />
    </div>
    <div
      *ngIf="imageLoading"
      fxLayout="column"
      fxLayoutAlign="center center"
      style="width: 600px; height: 350px"
      ngStyle.xs="width: 300px; height: 500px"
    >
      <mat-spinner
        diameter="35"
        mode="indeterminate"
        color="primary"
      ></mat-spinner>
    </div>
  </mat-dialog-content>
</div>
